import { createAction } from 'redux-actions';

export const setAllUsers = createAction('SET_ALL_USERS');